__webpack_require__.p = "/reports-details-row-collapse/referrals/";